import React from 'react';
import StockItemsPage from 'pages/shared/inventory-stock/stock-items-page';

const InventoryStockItems = () => {
  return <StockItemsPage defaultStoreType='main-store' />;
};

export default InventoryStockItems;
